import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";
import { createSlice } from "@reduxjs/toolkit";
import storageSession from "redux-persist/lib/storage/session";
import persistReducer from "redux-persist/es/persistReducer";
const initialState = {
  checkboxSelect: {},
  radioGroup: {},
  priceRange: {},
  singleSelect: {},
  filters: [],
  status: "idle",
  error: null,
  search: "",
  min_price: null,
  max_price: null,
  isFiltersEmpty: true,
};
// Async thunk for fetching filter data
export const fetchFilters = createAsyncThunk(
  "filters/fetchFilters",
  async () => {
    const authData = getAuthData();

    if (!authData.companyCode || !authData.groupCode || !authData.token) {
      throw new Error("signin");
    }
    const response = await fetch(
      process.env.REACT_APP_API_URL + "clientPortal/filter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          login: [
            ["token", "=", authData?.token],
            ["group_code", "=", authData?.groupCode],
            ["company_code", "=", authData?.companyCode],
          ],
        }),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch filters");
    }

    const data = await response.json();
    return data;
  },
);
// Helper function to check if filters are empty
const checkFiltersEmpty = (state) => {
  return (
    Object.keys(state.checkboxSelect).length === 0 &&
    Object.keys(state.radioGroup).length === 0 &&
    Object.keys(state.priceRange).length === 0 &&
    Object.keys(state.singleSelect).length === 0 &&
    !state.search
  );
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setCheckboxSelect: (state, action) => {
      const { filterId, selectedValues } = action.payload;
      state.checkboxSelect[filterId] = selectedValues;
      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    setSingleSelect: (state, action) => {
      const { filterId, selectedValue } = action.payload;
      state.singleSelect[filterId] =
        selectedValue !== undefined ? selectedValue.value : undefined;
      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    setRadioGroup: (state, action) => {
      const { filterId, selectedValue } = action.payload;
      state.radioGroup[filterId] = selectedValue;
      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    setPriceRange: (state, action) => {
      const { filterId, priceRange } = action.payload;
      state.priceRange[filterId] = priceRange;
      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    updatePriceRange: (state, action) => {
      const { min_price, max_price } = action.payload;

      if (min_price !== null && min_price !== undefined) {
        state.min_price = min_price;
      }

      if (max_price !== null && max_price !== undefined) {
        state.max_price = max_price;
      }

      state.isFiltersEmpty = checkFiltersEmpty(state);
    },
    resetFilters: (state) => {
      state.checkboxSelect = {};
      state.radioGroup = {};
      state.priceRange = {};
      state.singleSelect = {};
      state.search = "";
      state.isFiltersEmpty = true;
    },
    resetFiltersStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilters.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFilters.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.filters = action.payload;
        state.min_price = action.payload.min_price;
        state.max_price = action.payload.max_price;
        state.isFiltersEmpty = checkFiltersEmpty(state);
      })
      .addCase(fetchFilters.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    // .addCase(setCheckboxSelect, (state) => {
    //   state.priceRange = { range: [] }; // Reset price range whenever setCheckboxSelect runs
    // });
  },
});

export const {
  setCheckboxSelect,
  setRadioGroup,
  resetPriceRange,
  setPriceRange,
  setSearch,
  setSingleSelect,
  updatePriceRange,
  resetFilters,
  resetFiltersStatus,
} = filtersSlice.actions;
export const selectFilters = (state) => state.filters;
export const selectIsFiltersEmpty = (state) => state.filters.isFiltersEmpty;
const filtersPersistConfig = {
  key: "filters",
  storage: storageSession,
};
const persistedFiltersReducer = persistReducer(
  filtersPersistConfig,
  filtersSlice.reducer,
);

export default persistedFiltersReducer;
